import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import * as getters from './getters.js';
import mutations from './mutations.js';
import * as actions from './action.js';

// import appointment from './modules/appointment.js';

Vue.use(Vuex);

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	// modules: {
	// 	appointment
	// }
});



// WEBPACK FOOTER //
// ./src/store/index.js